import { render, staticRenderFns } from "./monthly.vue?vue&type=template&id=066c6cee&scoped=true"
import script from "./monthly.vue?vue&type=script&lang=js"
export * from "./monthly.vue?vue&type=script&lang=js"
import style0 from "./monthly.vue?vue&type=style&index=0&id=066c6cee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c6cee",
  null
  
)

export default component.exports